export type PagingInput = {
  pageNo: number;
  pageSize: number;
};

export const DEFAULT_PAGING: PagingInput = {
  pageNo: 1,
  pageSize: 10,
};

export type SortDirection = 'ASC' | 'DESC';

export type IOrder = {
  direction: SortDirection;
  field: string;
};

export const DEFAULT_ORDER: IOrder = {
  direction: 'ASC',
  field: 'CreatedDate',
};

/** Frontend adapter: UI still passes `{ where, paging }`; hooks map that to gateway scalars. */
export type ListQueryVariables<TWhere = Record<string, unknown>> = {
  where?: TWhere | null;
  order?: IOrder | null;
  paging?: PagingInput | null;
};

export interface MutationResult {
  itemId: string | null;
  totalImpactedData: number;
  acknowledged: boolean;
}
